import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    withCredentials: true
})

axiosInstance.interceptors.request.use(
    (config) => {
        const getCookie = (name) => {
            const value = `; ${document.cookie}`
            const parts = value.split(`; ${name}=`)
            if (parts.length === 2) return parts.pop().split(';').shift()
        }
        const token = getCookie('csrftoken')
        if (token) config.headers['X-CSRFToken'] = token
        return config
    },
    (error) => Promise.reject(error)
)

let isRefreshing = false
let failedQueue = []

const processQueue = (error) => {
    failedQueue.forEach(({ resolve, reject }) => error ? reject(error) : resolve())
    failedQueue = []
}

const addToQueue = (originalRequest) =>
    new Promise((resolve, reject) => failedQueue.push({ resolve, reject }))
        .then(() => axiosInstance(originalRequest))

axiosInstance.interceptors.response.use(
    (response) => response,

    async (error) => {
        const originalRequest = error.config

        if (error.response?.status !== 401) return Promise.reject(error)
        if (originalRequest.url?.includes('auth/login')) return Promise.reject(error)
        if (originalRequest.url?.includes('auth/refresh')) return Promise.reject(error)
        if (originalRequest._retry) return Promise.reject(error)
        if (isRefreshing) return addToQueue(originalRequest)

        originalRequest._retry = true
        isRefreshing = true

        try {
            await axiosInstance.post('auth/refresh')
            processQueue(null)
            return axiosInstance(originalRequest)
        } catch (refreshError) {
            processQueue(refreshError)
            window.dispatchEvent(new Event('auth:logout'))
            return Promise.reject(refreshError)
        } finally {
            isRefreshing = false
        }
    }
)

export default axiosInstance